var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 28,
    viewBox: "0 0 43 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7984 27.6L18.9984 0H12.3984L0.398438 27.6H11.7984ZM35.7984 27.6L42.9984 0H36.3984L24.3984 27.6H35.7984Z",
    fill: "url(#paint0_linear_310_509)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_509",
    x1: 28.8615,
    y1: -24.7969,
    x2: 41.7939,
    y2: 24.1471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00887753,
    stopColor: "#DEF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1723,
    stopColor: "#BEF3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4204,
    stopColor: "#9DEDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5512,
    stopColor: "#7DE7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7154,
    stopColor: "#5CE1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BBCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.c8bb1da8320f056e0e1cf903465cc3a6.svg";
export { ForwardRef as ReactComponent };